
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#oenotourism_svg__clip0_7935_26416)","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M52.757 19.315c-2.768-1.96-7.819-6.377-7.819-10.632a7.811 7.811 0 013.91-6.769 7.825 7.825 0 017.818 0 7.811 7.811 0 013.91 6.77c0 4.254-5.052 8.682-7.82 10.631z","stroke":"#1D1D1B"}}),_c('path',{attrs:{"d":"M52.757 10.667a2.087 2.087 0 100-4.175 2.087 2.087 0 000 4.175z","stroke":"#1D1D1B"}}),_c('path',{attrs:{"d":"M.865 46.045V12.396l20.757 5.766V33.95M1.234 53.068V51.12M21.622 49.966v13.17L.864 57.368M42.378 35.656v-23.26l-20.756 5.766V33.95M21.622 49.966v13.169l20.756-5.766V46.22M42.378 35.656v-23.26M60.575 17.447l2.56.715v44.973L42.378 57.37V46.22","stroke":"#B69E64"}}),_c('path',{attrs:{"d":"M26.88 37.985l-20.56-.046 6.86 6.434.52 9.387 13.18-15.775zM13.18 44.373l13.7-6.388M29.36 37.12s.391-.208 1.06-.45","stroke":"#1D1D1B"}}),_c('path',{attrs:{"d":"M34.895 36.001c2.975.197 6.503 1.834 8.89 7.496 4.994 11.866 20.503 3.194 10.171-6.193-5.777-5.246-5.074-9.26-3.575-11.635","stroke":"#1D1D1B","stroke-dasharray":"2 3"}}),_c('path',{attrs:{"d":"M51.857 23.94c.52-.473.9-.715.9-.715","stroke":"#1D1D1B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"oenotourism_svg__clip0_7935_26416"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h64v64H0z"}})])])])
          )
        }
      }
    